import React from 'react';
import ReactDOM from 'react-dom';
import BlockHolder from './block-holder.jsx';
import BlockHighlight from './block-highlight.jsx';
import {getBlockById, blocksHasSubstack, blocksInfo} from './blocks.js';
import event, {EVENTS} from '../lib/event.js';
import {createAnimate, endAnimate, parseTranslate, isNumber} from './utils.js';
import ScratchBlocks from 'scratch-blocks';
import {getInputField} from "./blocks";
import {getElementRect, isInElement} from "../lib/utils";
import Audio from "../lib/audio";
import {cardToText, tipsToCard} from './steps-runtime';
import {OPACITY_FOCUS_COVER, ZINDEX_FOCUS_COVER, ZINDEX_TIPS_ARROW} from '../lib/constant';

let div;

const clearCover = () => {
    if (div) {
        ReactDOM.unmountComponentAtNode(div);
        document.querySelector('div[class^="gui_codeStage"]').removeChild(div)
        div = null;
    }
};

const render = cpt => {
    if (!div) {
        div = document.createElement('div');
        div.id = "global_cover";
        document.querySelector('div[class^="gui_codeStage"]').appendChild(div)
        // document.body.appendChild(div);
    }
    ReactDOM.render(cpt, div);
};


//获取中间代码编辑区中的积木块的Node，不深入到Node内部的input或field
const getNodeInCodeWorkspace = (quote) => {
    const codeWorkspaceNode = document.querySelectorAll(".blocklyWorkspace")[0];
    const dataId = stepsRuntime.getBlockId(quote.argId || quote.id);
    return codeWorkspaceNode.querySelector(`[data-id="${dataId}"]`);
}

//获取中间代码编辑区中的积木块的Node，深入到Node内部的input或field
const getPreciseNodeInCodeWorkSpace = (quote) => {
    const inputField = getInputField(quote);
    if (inputField) {
        if (inputField.block) { //input的情况
            const block = getBlockById(inputField.block);
            if (block) {
                return getNodeInCodeWorkspace({id: block.id})
            }else {
                return null;
            }
        }else { //field的情况，目前支持只有一个field的情况，如果有多个，这里需要排序选择
            const codeWorkspaceNode = document.querySelectorAll(".blocklyWorkspace")[0];
            const dataId = stepsRuntime.getBlockId(quote.id);
            return codeWorkspaceNode.querySelector(`[data-id="${dataId}"]>[data-argument-type]:not([data-id])`);
        }

    }else {
        return getNodeInCodeWorkspace(quote);
    }
}

//获取左侧工具栏中的积木块的Node
const getNodeInToolbox = (source) => {
    const toolboxNode = document.querySelectorAll(".blocklyWorkspace")[1];
    if (source.id) { //优先使用ID匹配变量和自定义积木块
        let dataId = stepsRuntime.getBlockId(source.id);
        let node = toolboxNode.querySelector(`[data-id="${dataId}"]`);
        if (node) return node;
    }
    let text = '';
    if (source.opcode === 'data_variable') {
        text = source.varName;
    }else if (source.opcode === 'procedures_call') {
        text = source.proccode;
        text = text.replace(' %s ', ' ');
        text = text.replace(' %s', '');
        text = text.replace('%s ', '');
        text = text.replace(' %b ', ' ');
        text = text.replace(' %b', '');
        text = text.replace('%b ', '');
    }
    if (text) {
        let gs = toolboxNode.querySelectorAll(`g[data-id]`);
        for (let i = gs.length - 1; i >= 0; --i) {
            if (gInterText(gs[i]) === text) {
                return gs[i];
            }
        }
        return null;
    }else {
        let dataId = blocksInfo[source.opcode] && blocksInfo[source.opcode].dataId;
        if (!dataId) dataId = source.opcode;
        if (dataId) {
            let node = toolboxNode.querySelector(`[data-id="${dataId}"]`);
            if (node == null) { //有些积木块会根据当前不同角色携带id串前缀
                node = toolboxNode.querySelector('[data-id="' + vm.editingTarget.id + dataId.substr(dataId.lastIndexOf('_')) + '"]');
            }
            if (node == null) {
                node = toolboxNode.querySelector('[data-id="' + vm.editingTarget.id + '_' + dataId + '"]');
            }
            return node;
        }
    }
}

/**
 * g标签不支持interText，这里实现一个自己的，多个text节点之间用空格隔开，忽略空白text
 * @param {*} g
 */
const gInterText = (g) => {
    let texts = [];
    g.querySelectorAll("text").forEach(node=>{
        if (node.textContent.trim().length > 0) texts.push(node.textContent.trim());
    });
    return texts.join(" ");
}

/**
 * 获取积木块的位置数据
 * @param {object} quote - 目标位置的引用
 * @returns {object} 返回位置数据
 */
const getBlockRect = (quote) => {
    let node;
    //是否在toolbox区域
    node = getNodeInToolbox(quote);
    if (node) {
        node = node.querySelector('.blocklyBlockBackground');
        const rect = getElementRect(node);
        return  {
            left: rect.left ,
            top: rect.top,
            width: rect.width,
            height: rect.height
        };
    }
    //在代码区
    node = getNodeInCodeWorkspace(quote);
    if (node) {
        const dataId = node.getAttribute("data-id");
        const rect = getElementRect(node.querySelector('.blocklyBlockBackground'));
        let res = {
            left: rect.left,
            top: rect.top,
            width: rect.width,
            height: rect.height
        };
        if (quote.input) {
            if (quote.input.startsWith('SUBSTACK')) {
                res.left = res.left + 11;
                if (quote.input === 'SUBSTACK') {
                    res.top = res.top + 33;
                    const textEls = node.parentElement.querySelectorAll(`[data-id="${dataId}"]>text`);
                    if (textEls.length && textEls[textEls.length - 1].textContent === '否则') {
                        res.height = getElementRect(textEls[textEls.length - 1]).top - res.top;
                    }else {
                        res.height -= 33;
                    }
                }
                if (quote.input === 'SUBSTACK2') {
                    const textEls = node.parentElement.querySelectorAll(`[data-id="${dataId}"]>text`);
                    if (textEls.length && textEls[textEls.length - 1].textContent === '否则') {
                        const {top} = getElementRect(textEls[textEls.length - 1]);
                        res.height -= top + 19 -res.top;
                        res.top = top + 19;
                    } else {
                        console.error(`没有找到 ${dataId} 元素的第二个分支，请确认代码！`);
                        debugger;
                    }
                }
                //res.left += document.documentElement.scrollLeft;
                //res.top += document.documentElement.scrollTop;
                return res;
            }
            const block = getBlockById(quote.id);
            if (block && block.inputs && block.inputs[quote.input] && block.inputs[quote.input].block) { //子元素直接通过name能找到的情况
                node = getNodeInCodeWorkspace({id: block.inputs[quote.input].block});
                if (node) {
                    const rect = getElementRect(node.querySelector('.blocklyBlockBackground'));
                    return {
                        left: rect.left,
                        top: rect.top,
                        width: rect.width,
                        height: rect.height
                    };
                }
            }
        }
        if (quote.inputIndex != undefined) {
            let args = node.parentElement.querySelectorAll(`[data-id="${dataId}"]>[data-argument-type]`);
            let argPath = getArgPath(args, quote.inputIndex);
            if (argPath) {
                const {left, top, width, height} = getElementRect(argPath);
                res = {left, top, width, height};
            }else {
                res = null;
            }
        }
        //res.left += document.documentElement.scrollLeft;
        //res.top += document.documentElement.scrollTop;
        return res;
    }else if (quote.position) { //拖动到空白处
        const position = quote.position;
        const metrics = ScratchBlocks.mainWorkspace.getMetrics();
        const scale = ScratchBlocks.mainWorkspace.scale
        return {
            left: (position.absolute ? position.x : (document.querySelector('.blocklySvg').getBoundingClientRect().left + metrics.absoluteLeft -  metrics.viewLeft + (position.x) * scale)),
            top: (position.absolute ? position.y : (metrics.absoluteTop  - metrics.viewTop + (position.y) * scale)),
            width: 100,
            height: 100
        };
    }
    console.warn('没有找到 block');
    return null;
};

const getArgPath = (args, index) => {
    let nodes = [];
    for (let i = 0; i < args.length; ++i) {
        nodes.push(args[i]);
    }
    //参数排序
    nodes.sort((a, b)=>{
        return parseTranslate(a.getAttribute('transform')).x - parseTranslate(b.getAttribute('transform')).x;
    });
    let argPath = nodes[index];
    if (argPath && argPath.tagName != 'path') argPath = argPath.querySelector('path');
    if (argPath == undefined) {
        console.error(`目标参数位置不存在：${index}`);
    }
    return argPath;
}

const isVisibleInToolbox = (g) => {
    let transform = g.getAttribute("transform");
    let p = parseTranslate(transform);
    return !(p.y - window.toolbox.flyout_.getScrollPos() - window.toolbox.flyout_.getHeight() > 200
        || p.y < window.toolbox.flyout_.getScrollPos());
}

const toolboxScrollToBlock = async (quote) => {
    const node = getNodeInToolbox(quote)
    await toolboxScrollToNode(node);
}

const toolboxScrollToNode = async (node) => {
    if (!isVisibleInToolbox(node)) {
        let transform = node.getAttribute("transform");
        let p = parseTranslate(transform);
        let toPos;
        if (p.y < window.toolbox.flyout_.getScrollPos())
            toPos = p.y;
        else
            toPos = p.y - window.toolbox.flyout_.getHeight() / 2;
        /*
        toPos = Math.min((p.y - window.toolbox.flyout_.getHeight() / 2),
            (window.toolbox.flyout_.workspace_.getMetrics().contentHeight - window.toolbox.flyout_.workspace_.getMetrics().viewHeight) / window.toolbox.flyout_.workspace_.scale);
    let diff =  (window.toolbox.flyout_.getScrollPos() - toPos) * window.toolbox.flyout_.workspace_.scale;
    let rect = getBlockRect(type);
    let count = 0;

         */
        window.toolbox.flyout_.scrollTo(toPos);
        await new Promise(resolve => {
            let intval = setInterval(()=>{
                //count++;
                if (window.toolbox.flyout_.scrollTarget == null
                    /*&& (Math.abs(getBlockRect(type).top - rect.top - diff) < 5 || count > 50)*/) { //等待滚动动画结束
                    clearInterval(intval);
                    resolve();
                }
            }, 100);
        });
    }
}

/**
 * 移动代码区，确保目标位置可见。如果移动了，返回true
 * target是目标块引用，或element
 * isBelow 是否移动到目标下方
 */
const codeWorkspaceScrollToTarget = (target, isBelow) => {
    let rect;
    if (target.parentElement) {
        rect = getElementRect(target);
    }else {
        rect = getBlockRect(target);
    }
    if (rect == null) {
        return null;
    }

    if (isBelow) { //积木块放到target的下方
        rect.top = rect.top + rect.height - 5;
    }
    const metrics = ScratchBlocks.mainWorkspace.getMetrics();
    const scale = ScratchBlocks.mainWorkspace.scale
    //TODO 异常情况，新建自定义积木块后，Blockly.getMainWorkspace下的很多东西会被重置，此时不移动画布。这个是Scratch自带的问题，需要找到问题的根源去修复它
    if (metrics.contentHeight == 0) {
        return false;
    }

    const startLeft = document.querySelector('[class^="gui_editor"]').getBoundingClientRect().left; //整个blockly布局的起始位置
    //const flyoutWidth = window._Blockly.mainWorkspace.getFlyout().getWidth();
    const right = metrics.viewWidth + metrics.absoluteLeft + startLeft;
    const left = metrics.absoluteLeft + startLeft;
    const bottom = metrics.viewHeight + metrics.absoluteTop + 93;
    const top = metrics.absoluteTop + 93;
    if (rect.left > right - 150 //右边超出
        || rect.left < left + 50   // 左边超出
        || rect.top < top  + 50  // 上边超出
        || rect.top > bottom - 150) { //下边超出
        let x = rect.left - metrics.absoluteLeft + metrics.viewLeft - metrics.contentLeft - 50; //以flyout展开为准，如果小于这个边界，略微往右移动一点 // - metrics.viewWidth * 1 / 3;
        x -= startLeft; //左侧聊天窗口造成的偏移修正
        let y = rect.top - metrics.absoluteTop + metrics.viewTop - metrics.contentTop - metrics.viewHeight * 1 / 2;
        window.scrollbar.set(x, y);
        return true;
    }else {
        return false;
    }
}

/**
 * 聚焦左侧 toolbox 中的一个积木块，并且移动代码区使目标位置可见
 * @param {object} args - 参数
 * @param {object} source - 可能为积木块的quote，也可能是一个DOM元素
 * @param {object} target
 * @param {string} args.tips - 提示信息
 * @param {boolean} noTips - 不显示tips
 * @param {boolean} args.noAudio - 是否播放提示音
 * @param {left, top, width, height} args.sourceOffset - 偏移量
 * @param {number} args.zIndex - 设置 z-index，默认值为 511，比gui自带的modal高1
 * @param {boolean} args.noModal - 不显示modal
 * @param {number} args.forcePoint - 强制箭头方向，1从左指向右，2从右指向左
 * @param {string} args.pointerEvents - 高亮部分是否成为鼠标点击事件的target，如果不设置或none，鼠标事件透传到下面一层。如果设置为auto，会接收到鼠标事件
 * @param {function} args.reject
 */
const focusBlock = async ({source, target, tips, noTips, noAudio, sourceOffset, zIndex, noModal, forcePoint, pointerEvents, reject}, mode, _index) => {
    event.emit(EVENTS.CLEAR_COVER);
    if (!noTips && tips) {
        if (mode) {
            window.stepsRuntime.insertTips(_index, tips, noAudio);
        }else {
            if (!noAudio) Audio.tts(tips);
        }
    }
    if (zIndex === undefined) zIndex = ZINDEX_FOCUS_COVER;
    let sourceRect;
    let targetRect;
    let opacity = OPACITY_FOCUS_COVER;
    let moved = false;
    let sourceInWorkspace = false;
    if (source) {
        if (source.parentElement == undefined) { //积木块
            //先滚动到可见位置
            let sourceBlockNode = getNodeInToolbox(source);
            if (sourceBlockNode) {
                await toolboxScrollToBlock(source);
            }else {
                sourceBlockNode = getNodeInCodeWorkspace(source);
                if (sourceBlockNode) {
                    sourceInWorkspace = true;
                    moved = codeWorkspaceScrollToTarget(source);
                }else {
                    console.error('出问题了，没有找到Source块：', source);
                    reject("没有找到：" + JSON.stringify(source));
                    return;
                }
            }
            sourceRect = getBlockRect(source);
        }else {
            let isInCodeWorkSpace = false;
            if (isInElement(source, document.querySelectorAll(".blocklyWorkspace")[0])) { //如果目标块在代码区，需要进行滚动
                codeWorkspaceScrollToTarget(source);
                isInCodeWorkSpace = true;
            }
            const {left, top, width, height} = getElementRect(source);
            sourceRect = {left, top, width, height};

            //超出可视范围，寻找最近一个可滚动的父节点进行滚动
            if (!isInCodeWorkSpace &&
                (sourceRect.top < 0 || sourceRect.top + sourceRect.height > window.appTarget.getBoundingClientRect().height)
            ) {
                let t = source;
                while (t) {
                    if (t.scrollHeight > t.clientHeight) {
                        const scrollParentRect = t.getBoundingClientRect();
                        if (sourceRect.top < scrollParentRect.top || sourceRect.top + sourceRect.height > scrollParentRect.top + scrollParentRect.height) {
                            const oriScrollTop = t.scrollTop;
                            if (sourceRect.top < scrollParentRect.top) {
                                t.scrollTop -= scrollParentRect.top - sourceRect.top + 50;
                            }else {
                                t.scrollTop += (sourceRect.top + sourceRect.height) - (scrollParentRect.top + scrollParentRect.height) + 50;
                            }
                            sourceRect.top -= t.scrollTop - oriScrollTop;
                        }
                        break;
                    }
                    t = t.parentElement;

                }
            }
        }

    }else {
        reject('缺少source');
    }
    if (target) {
        //TODO 应该尽量移动到source和target都可见的位置
        if (!sourceInWorkspace) codeWorkspaceScrollToTarget(target, target.input === undefined);
        if (target.id || target.position) {
            targetRect = getBlockRect(target);
        }
    }
    if (targetRect && target.input === undefined) { //积木块放到下方
        targetRect.top = targetRect.top + targetRect.height - 5;
    }
    //交换source和target，支持只有一个目标位置的情况
    if (!sourceRect && targetRect) {
        let t = sourceRect;
        sourceRect = targetRect;
        targetRect = t;
    }
    if (sourceRect) {
        if (sourceOffset) {
            //舞台区采用480*360虚拟坐标
            if (typeof(source.className) == 'string' && source.className.indexOf("stage_stage_") === 0) {
                const scale = source.clientWidth / 480;
                if (sourceOffset.left) sourceOffset.left *= scale;
                if (sourceOffset.top) sourceOffset.top *= scale;
                if (sourceOffset.width) sourceOffset.width *= scale;
                if (sourceOffset.height) sourceOffset.height *= scale;
                if (sourceOffset.paddingLeft) sourceOffset.paddingLeft *= scale;
            }
            if (sourceOffset.left) sourceRect.left += sourceOffset.left;
            if (sourceOffset.top) sourceRect.top += sourceOffset.top;
            if (sourceOffset.width) sourceRect.width = sourceOffset.width;
            if (sourceOffset.height) sourceRect.height = sourceOffset.height;
            if (sourceOffset.paddingLeft) sourceRect.width = sourceRect.width - sourceOffset.paddingLeft
        }
        let hasRun = false;
        const events = ['move', 'create'];
        let sourceToTargetTimer = undefined; //从source到target到动画
        const createDragGuideAnimate = info => {
            if (hasRun) {
                return;
            }
            if (sourceToTargetTimer) { //取消从source到target到动画
                clearInterval(sourceToTargetTimer);
                sourceToTargetTimer = undefined;
                endAnimate();
                //event.emit(EVENTS.CLEAR_COVER);
            }
            let blockId;
            if (info.blockId) blockId = info.blockId;
            else if (info.newValue) blockId = info.newValue;
            events.forEach(e => {
                event.off(e, createDragGuideAnimate);
            });
            hasRun = true;
            if (targetRect) {
                let timer = setInterval(() => {
                    const find = document.querySelector(`[data-id="${blockId}"]`);

                    if (find) {
                        createAnimate(
                            find.getBoundingClientRect(),
                            {left: targetRect.left - document.documentElement.scrollLeft, top: targetRect.top - document.documentElement.scrollTop, width: targetRect.width, height: targetRect.height}
                        );
                    }
                }, 200);
                event.once(EVENTS.END_DRAG_AND_MOVE, () => {
                    if (timer) {
                        clearInterval(timer);
                        timer = undefined;
                        endAnimate();

                    }
                    event.emit(EVENTS.CLEAR_COVER);
                });
                event.once(EVENTS.CLEAR_COVER, ()=>{
                    if (timer) {
                        clearInterval(timer);
                        timer = undefined;
                        endAnimate();
                    }
                });
            }
            opacity = 0;
            renderCover();
        };
        if (targetRect) {
            //创建从source到target到动画
            sourceToTargetTimer = setInterval(() => {
                createAnimate(sourceRect, targetRect);
            }, 200);
            event.once(EVENTS.CLEAR_COVER, () => {
                if (sourceToTargetTimer) {
                    clearInterval(sourceToTargetTimer);
                    sourceToTargetTimer = undefined;
                    endAnimate();
                }
            });
                //延迟创建动画，避免上一个动作的events还有残留，导致动画追踪的source块被错误定位
            setTimeout(() => {
                events.forEach(e => {
                    event.once(e, createDragGuideAnimate);
                });
            }, 500);
        }else {
            //延迟创建动画，避免上一个动作的events还有残留，导致动画追踪的source块被错误定位
            const doClearCover = () => {
                events.forEach(e => {
                    event.off(e, doClearCover);
                    event.emit(EVENTS.CLEAR_COVER);
                })
            };
            setTimeout(() => {
                events.forEach(e => {
                    event.once(e, doClearCover);
                });
            }, 500);
        }
        let argPath;
        if (target && target.inputIndex != undefined) {
            //优先使用input的name来匹配
            const targetBlock = getBlockById(target.id);
            if (targetBlock && targetBlock.inputs && targetBlock.inputs[target.input] && targetBlock.inputs[target.input].block) { //子元素直接通过name能找到的情况
                const node = getNodeInCodeWorkspace({id: targetBlock.inputs[target.input].block});
                if (node) {
                    argPath = node.querySelector('path');
                }
            }
            //再按index匹配，这里是有问题的，因为如果参数值是变量之类的情况data-argument-type是不存在的
            const node = getNodeInCodeWorkspace(target);
            if (node) {
                const dataId = node.getAttribute('data-id');
                const args = node.parentElement.querySelectorAll(`[data-id="${dataId}"]>[data-argument-type]`);
                if (args.length > target.inputIndex)
                    argPath = getArgPath(args, target.inputIndex);
            }
        }
        let tipsPos = {}, arrowPos = {};
        let leftPoint = (sourceRect.left + sourceRect.width / 2) > document.body.clientWidth / 2;
        if (forcePoint === 1) leftPoint = true;
        else if (forcePoint === 2) leftPoint = false;
        if (leftPoint) {
            tipsPos.right = document.body.clientWidth - sourceRect.left + 90;
            arrowPos = {
                right: -70,
                top: 0,
                transform: "rotateY(180deg)"
            }
        }else {
            tipsPos.left = sourceRect.left + sourceRect.width + 90 - 268;
            arrowPos = {
                left: -70,
                top: 0,
            }
        }
        const renderCover = ()=> {
            render(
                <React.Fragment>
                    {!noModal && (
                        <BlockHighlight
                            opacity={opacity}
                            zIndex={zIndex}
                            getCurrentRect={() => sourceRect}
                            pointerEvents={pointerEvents}
                        />
                    )}
                    {
                        tips && (
                            <div
                                style={{
                                    display: hasRun ? 'none' : 'block',
                                    position: 'absolute',
                                    top: sourceRect.top,
                                    backgroundColor: 'hsla(30, 100%, 55%, 1)',
                                    border: '1px solid hsla(0, 0%, 0%, 0.15)',
                                    boxShadow: '0 0 .5rem hsla(0, 0%, 0%, 0.15)',
                                    borderRadius: 4,
                                    color: '#FFF',
                                    fontSize: 14,
                                    textAlign: 'center',
                                    padding: `8px 16px`,
                                    zIndex: ZINDEX_TIPS_ARROW,
                                    maxWidth: 260,
                                    ...tipsPos
                                }}
                            >
                                <span
                                    style={{
                                        position: 'absolute',
                                        width: 50,
                                        height: 30,
                                        background: `url(${require('./assets/left-arrow.gif')}) no-repeat center / contain`,
                                        ...arrowPos
                                    }}
                                />
                                {cardToText(tipsToCard(-1, tips))}
                            </div>
                        )
                    }
                    {
                        argPath ? ( //菱形参数，按序列指定，从0开始
                            <BlockHolder
                                rect={targetRect}
                                path={argPath}
                                zIndex={zIndex}
                            />
                        ):(
                            targetRect && (
                                <BlockHolder
                                    left={targetRect.left}
                                    top={targetRect.top}
                                    zIndex={zIndex}
                                />
                            )
                        )
                    }
                </React.Fragment>
            );

        }
        renderCover();
        // window.onresize = () => {
        //     renderCover();
        //     event.on('CLEAR_COVER',clearCover())
        // }
        let timer
        const replay = ()=>{
            clearTimeout(timer)
           timer =  setTimeout(()=>{
                focusBlock({source, target, tips, noTips, noAudio, sourceOffset, zIndex, noModal, forcePoint, pointerEvents, reject}, mode, _index);
            },200)
        }
        window.addEventListener('resize', replay)


        event.once(EVENTS.CLEAR_COVER,()=>{
            window.removeEventListener('resize', replay);
        })
    }
    return true;
};

export {
    render,
    focusBlock,
    clearCover,
    getBlockRect,
    getNodeInCodeWorkspace,
    getPreciseNodeInCodeWorkSpace,
    getNodeInToolbox,
    gInterText,
    toolboxScrollToBlock,
    toolboxScrollToNode
};
